import type { RequiredGeneric } from '@pba/react-utils';
import { Form, FormSection, Icon, Input, Segmented, type SegmentedOptions } from 'ui';

const eventTypeOptions: SegmentedOptions<ExtendedDetailFormContentValues['type']> = [
  {
    icon: <Icon icon="camcorder-line" />,
    label: 'Video Conference',
    tooltip: 'Up to 64 participants total. Interactive mode: all can share camera and audio',
    value: 'video_conference',
  },
  {
    icon: <Icon icon="presentation-2-line" />,
    label: 'Webinar',
    tooltip:
      'Up to 64 admins/presenters with 1000 participants total. Presentation mode: Attendees can view, hear, chat, etc.',
    value: 'webinar',
  },
];

export type CreateEventType = 'video_conference' | 'webinar';

export type ExtendedDetailFormContentValues = {
  name: string;
  type: CreateEventType;
};

type Mode = 'create' | 'duplicate' | 'edit';

type P = {
  mode: Mode;
};

const isTypeDisabled = (mode: Mode) => mode === 'edit' || mode === 'duplicate';

const DetailFormContent = <T extends ExtendedDetailFormContentValues = never>({ mode }: RequiredGeneric<T, P>) => (
  <FormSection title={{ children: 'Event details', icon: <Icon icon="calendar-line" /> }}>
    <Form.Item<ExtendedDetailFormContentValues>
      label="Event name"
      name="name"
      rules={[{ required: true, whitespace: true }]}
    >
      <Input />
    </Form.Item>
    <Form.Item<ExtendedDetailFormContentValues> name="type" rules={[{ required: true }]}>
      <Segmented<ExtendedDetailFormContentValues['type']>
        disabled={isTypeDisabled(mode)}
        options={eventTypeOptions}
        size="large"
      />
    </Form.Item>
  </FormSection>
);

export default DetailFormContent;
